const SOFTWARE_TYPES = {
    TRUTOPS: "TruTops",
    TRUTOPS_FAB: "TruTops Fab",
    TRUTOPS_BOOST: "TruTops Boost"};
const getSoftwareTypes = (softwares) => {
    return Array.from(new Set(softwares.map((software) => software.softwareType)));
};
const getSoftwareModulesByType = (softwares, softwareType) => {
    return Array.from(new Set(softwares.filter((software) => software.softwareType === softwareType).map((software) => software.softwareModule)));
};
const getSoftwareProductNumber = (softwares, softwareType, softwareModule) => {
    const software = softwares.find((software) => software.softwareType === softwareType && software.softwareModule === softwareModule);
    return software ? software.productNo : "";
};
const getSoftwares = async (apiClient) => {
    return apiClient.request("/servicecall/getsoftware", {
        mockResponse: mockSoftwares
    });
};
const mockSoftwares = [
    {
        softwareType: "TruTops",
        softwareModule: "CAD",
        productNo: "9TWDEDEMOS415"
    },
    {
        softwareType: "TruTops Fab",
        softwareModule: "Storage",
        productNo: "9TWDEDEMOS612"
    },
    {
        softwareType: "TruTops",
        softwareModule: "Laser",
        productNo: "9TWDEDEMOS415"
    },
    {
        softwareType: "TruTops",
        softwareModule: "Tube",
        productNo: "9TWDEDEMOS415"
    },
    {
        softwareType: "TruTops",
        softwareModule: "Punch",
        productNo: "9TWDEDEMOS415"
    },
    {
        softwareType: "TruTops",
        softwareModule: "Bend",
        productNo: "9TWDEDEMOS415"
    },
    {
        softwareType: "TruTops Cell",
        softwareModule: "TruTops Cell",
        productNo: "9TWDEDEMOS185"
    },
    {
        softwareType: "TruTops Fab",
        softwareModule: "Quickjob",
        productNo: "9TWDEDEMOS612"
    },
    {
        softwareType: "TruTops Boost",
        softwareModule: "HomeZone",
        productNo: "9TWDEDEMOS872"
    },
    {
        softwareType: "TruTops Boost",
        softwareModule: "Design",
        productNo: "9TWDEDEMOS872"
    },
    {
        softwareType: "TruTops Boost",
        softwareModule: "Cut",
        productNo: "9TWDEDEMOS872"
    },
    {
        softwareType: "TruTops Boost",
        softwareModule: "Bend",
        productNo: "9TWDEDEMOS872"
    },
    {
        softwareType: "TruTops Weld",
        softwareModule: "TruTops Weld",
        productNo: "9TWDEDEMOS901"
    },
    {
        softwareType: "Programming Tube",
        softwareModule: "Programming Tube",
        productNo: "9TWDEDEMOS873"
    }
];

const ERROR_SOURCES_MAPPING = {
    UNDEFINED: ["MMC"],
    ELECTRONICS: [
        "TruControl",
        "TruConvert",
        "TruPlasma VHF",
        "TPR1000_G2_TPR3000_G2",
        "TPM7000_G2_THM7000_G2",
        "TPR3000",
        "THM7000_G3"
    ],
    LASER: ["MMC", "TruControl"],
    PUNCHING: ["MMC"],
    COMBINED: ["MMC", "TruControl"],
    BENDING: ["MMC"],
    SOFTWARE: [],
    CO2LASER: ["TruControl"],
    SOLIDSTATELASER: ["TruControl"],
    MARKINGLASER: ["TruControl"],
    AQUACUT: ["MMC"],
    TRUSHEAR: ["MMC"],
    AUTOMATION: ["MMC"],
    "2DLASERCUTTING": ["MMC", "TruControl"],
    "3DLASERCUTTING": ["MMC", "TruControl"],
    "3DPRINTING": ["AM_HMI", "AM_DESKTOP", "AM_TITP"],
    COOLER: ["MMC"],
    DIODELASER: ["TruControl"],
    DISKLASER: ["TruControl"],
    FIBERLASER: ["TruControl"],
    PULSEDLASER: ["TruControl"],
    WELDING: ["MMC", "TruControl"],
    SHORTPULSEDLASER: ["TruControl"],
    STORAGESYSTEM: ["MMC"],
    LASERTUBECUTTING: ["MMC", "TruControl"]
};
const FALLBACK_ERROR_SOURCES = ["MMC"];
const getErrorSourcesForTechnology = (productTechnology) => {
    if (!productTechnology) {
        return FALLBACK_ERROR_SOURCES;
    }
    return ERROR_SOURCES_MAPPING[productTechnology] || FALLBACK_ERROR_SOURCES;
};
const getErrorNumberRegexForTechnology = (technology) => {
    const errorSources = getErrorSourcesForTechnology(technology);
    return errorSources.map((source) => `(${ERROR_SOURCE_REGEX[source]})`).join("|");
};
const ERROR_SOURCE_REGEX = {
    MMC: "^([0-9]+)([\\.][0-9]+)*$",
    TruControl: "^[a-fA-F0-9]{4}( |\\.)?[a-fA-F0-9]{4}$",
    AM_HMI: "^[0-9]*$",
    AM_DESKTOP: "^[0-9]*$",
    AM_TITP: "^[A-Z]{3,4}(-)[0-9]{5}$",
    TruConvert: "^[0-9]{5}$",
    "TruPlasma VHF": "/^[0-9]{5}$",
    TPR1000_G2_TPR3000_G2: "^[0-9]{5}$",
    TPM7000_G2_THM7000_G2: "^[0-9]{5}$",
    TPR3000: "^[0-9]{5}$",
    THM7000_G3: "^[0-9]{5}$"
};
const UNKNOWN = "UNDEFINED";
const getErrorSourceForErrorNumber = (errorNumber, technology) => {
    const filteredErrorSources = getErrorSourcesForTechnology(technology).filter((errorSource) => {
        if (new RegExp(ERROR_SOURCE_REGEX[errorSource]).test(errorNumber)) {
            return errorSource;
        }
        return false;
    });
    if (filteredErrorSources.length === 0) {
        return UNKNOWN;
    }
    return filteredErrorSources[0];
};

const isSingleSelect = (select) => {
    return "nodeName" in select;
};
const getApplicationOptionsFromForm = (form) => {
    var _a;
    const applicationOptions = [];
    if (!form["application"]) {
        return applicationOptions;
    }
    if (isSingleSelect(form["application"])) {
        applicationOptions.push(parseInt(form["application"].value, 10));
    }
    else {
        (_a = form["application"]) === null || _a === void 0 ? void 0 : _a.forEach((select) => {
            if (select.value) {
                applicationOptions.push(parseInt(select.value, 10));
            }
        });
    }
    return applicationOptions.filter((id) => !isNaN(id));
};

const createRequestData = ({ form, callId, softwares, selectedMachineTechnology, origin }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const formData = {
        callId,
        createdWith: "MyTRUMPF", // TODO: change to "MicroFrontend" when the backend is ready (this is validated in the backend)
        origin: origin || "", // e.g. "oseon" - this is not implemented on the backend yet
        notificationType: Number(form["notificationType"].value),
        description: form["description"].value,
        callBackContact: {
            salutation: Number(form["salutation"].value),
            firstName: form["firstName"].value,
            lastName: form["lastName"].value,
            phone: form["phone"].value,
            email: form["email"].value
        },
        equipmentNo: (_a = form["productNo"]) === null || _a === void 0 ? void 0 : _a.value,
        hmiErrorsWithInfo: Array.from(form.querySelectorAll("service-calls-dynamic-input input")).map((el) => ({
            errorNumber: el.value,
            errorSource: getErrorSourceForErrorNumber(el.value, selectedMachineTechnology)
        })),
        software: {
            productNumber: getSoftwareProductNumber(softwares, (_b = form["softwareType"]) === null || _b === void 0 ? void 0 : _b.value, (_c = form["softwareModule"]) === null || _c === void 0 ? void 0 : _c.value),
            softwareModule: (_d = form["softwareModule"]) === null || _d === void 0 ? void 0 : _d.value,
            softwareType: (_e = form["softwareType"]) === null || _e === void 0 ? void 0 : _e.value,
            isInstallationProblem: (_f = form["installationProblem"]) === null || _f === void 0 ? void 0 : _f.checked,
            isLicenseIssue: (_g = form["licenseIssue"]) === null || _g === void 0 ? void 0 : _g.checked,
            softwareProblemClassification: (_h = form["softwareProblemClassification"]) === null || _h === void 0 ? void 0 : _h.value
        },
        applicationTopicOptions: getApplicationOptionsFromForm(form),
        purchaseOrderNumber: null, // there is no field in the form
        additionalText: null // there is no field in the form
    };
    return formData;
};
const TRANSACTION_STATES = {
    RECEIVED: "Received" // other states tbd
};

export { SOFTWARE_TYPES as S, TRANSACTION_STATES as T, getSoftwareTypes as a, getErrorNumberRegexForTechnology as b, getSoftwareModulesByType as c, getApplicationOptionsFromForm as d, createRequestData as e, getSoftwares as g };
//# sourceMappingURL=createCase-BGqTFsuJ.js.map

//# sourceMappingURL=createCase-BGqTFsuJ.js.map